<template>
    <div>
        <div v-if="title && !reduced" class="font-weight-bold text-uppercase">
            {{ title }}
        </div>
        <slot></slot>
        <div class="d-flex justify-center my-2" v-if="!reduced">
            <v-btn
                :disabled="!valid" 
                @click="$emit('handleSave')">
                Salva configurazione</v-btn>
            <v-btn class="ml-2" @click="$emit('restore')" text>
                ripristina
            </v-btn>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        valid: {
            type: Boolean,
            required: true
        },
        reduced: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
        }
    },
}
</script>    